import { render, staticRenderFns } from "./VisitasComponent.vue?vue&type=template&id=69cbd8d6"
import script from "./VisitasComponent.vue?vue&type=script&lang=js"
export * from "./VisitasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports